import { init, captureConsoleIntegration } from '@sentry/nextjs';
import { defaultConfig } from './defaultConfig';

export const initSentryOnServer = () => {
  init({
    ...defaultConfig,
    integrations: [
      captureConsoleIntegration({
        handled: false,
        levels: ['error'],
      }),
    ],
  });
};
